import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, Grid, Typography } from "@mui/material";
import Image from "next/image";
import officeImg1 from "../../public/assets/images/home/more/career/officeImg1.webp";
import officeImg2 from "../../public/assets/images/home/more/career/officeImg2.webp";
import officeImg3 from "../../public/assets/images/home/more/career/officeImg3.webp";
import officeImg4 from "../../public/assets/images/home/more/career/officeImg4.webp";
import officeImg5 from "../../public/assets/images/home/more/career/officeImg5.webp";
import officeImg6 from "../../public/assets/images/home/more/career/officeImg6.webp";

const images = [
  { src: officeImg5, alt: "officeImg5" },
  { src: officeImg6, alt: "officeImg6" },
  { src: officeImg4, alt: "officeImg4" },
  { src: officeImg3, alt: "officeImg3" },
  { src: officeImg2, alt: "officeImg2" },
  { src: officeImg1, alt: "officeImg1" },
];

const settings = {
  infinite: false,
  speed: 1500,
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: true,
  easing: "linear",
  slidesToShow: 1,
  ariaHidden: true,
  slidesToScroll: 1,
};

function GromoGalleryMobile() {
  return (
    <Grid sx={{ margin: "24px 0 0 0" }}>
      <Typography
        sx={{
          color: "#0A0C0F",
          fontSize: { xs: "18px", md: "32px" },
          lineHeight: { xs: "32px", md: "40px" },
          wordSpacing: { xs: "2px" },
          fontWeight: 500,
          textAlign: "center",
          margin: { xs: "50px auto 20px auto", md: "0 0 15px 0" },
          width: "80%",
        }}
      >
        Collaborate with the best of
        <Box component="br" sx={{ display: { xs: "block", sm: "none" } }} />
        <span style={{ fontWeight: 700, fontSize: "28px", margin: "0 4px" }}>
          brains
        </span>
        and
        <span style={{ fontWeight: 700, fontSize: "28px", margin: "0 4px" }}>
          hearts
        </span>
      </Typography>
      <Slider {...settings}>
        {images.map((img, idx) => (
          <Grid
            key={idx}
            sx={{
              padding: { xs: "16%", md: "2%" },
              display: "grid !important",
              placeContent: "center",
              margin: "auto",
            }}
          >
            <Image
              src={img.src}
              alt={img.alt}
              style={{
                objectFit: "contain",
                borderRadius: "12px",
                height: "350px",
              }}
              loading="lazy"
            />
          </Grid>
        ))}
      </Slider>
    </Grid>
  );
}

export default GromoGalleryMobile;
